module.exports = __webpack_public_path__ + "img/customer.842f997.svg";